import { Film, Flame, Images } from 'lucide-react';
import React, { Suspense, useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router';

import Banner from '~/components/HomepageBanner';
import Loading from '~/components/Loading';

import { useAuth } from '~/modules/auth/useAuth';

import { useTranslation } from '~/hooks/useTranslation';

import styles from './_index.module.scss';

const Home = () => {
  const { isSignedIn } = useAuth();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === '/') {
      if (!isSignedIn) {
        navigate('/streams');
      } else {
        navigate('/feed');
      }
    }
  }, [isSignedIn, pathname]);

  return (
    <>
      <Banner />
      <nav className={styles.Home__SectionPicker}>
        {[
          {
            to: '/streams',
            icon: <Film size={16} />,
            label: t('Home_Streams', 'Streams'),
            show: true,
          },
          {
            to: '/feed',
            icon: <Flame size={16} />,
            label: t('Home_Feed', 'Feed'),
            show: isSignedIn,
          },
          {
            to: '/gallery',
            icon: <Images size={16} />,
            label: t('Home_Gallery', 'Gallery'),
            show: true,
          },
        ]
          .filter((item) => item.show)
          .map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `${styles.Home__SectionPickerOption} ${isActive ? styles.Home__SectionPickerOptionActive : ''}`
              }
            >
              {item.icon}
              <span className={styles.Home__SectionName}>{item.label}</span>
            </NavLink>
          ))}
      </nav>

      <Suspense fallback={<Loading />}>
        <Outlet />
      </Suspense>
    </>
  );
};

export default Home;
